import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {moduloGaritas} from '../../diccionarios/balanzaModulo.js';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {Subscription} from "rxjs";
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {UsuarioBasculaGaritaService} from '../../services/usuario-bascula-garita.service';
import {MantenimientoBasculaService} from '../../services/mantenimiento-bascula.service';
import {MantenimientoGaritasService} from '../../services/mantenimiento-garitas.service';
import {IGaritaResponse} from '../../modelos/IMantGarita';
import {IMantBascula} from '../../modelos/IMantBascula';
import {UsuariosService} from '../../services/usuarios.service';
import {IUsuarioAll} from '../../modelos/IUsuario.js';
import {ConfiguracionMotivosDeDesbloqueosService} from '../../services/configuracion-motivos-de-desbloqueos.service';

@Component({
  selector: 'app-configuracion-motivos-de-desbloqueos',
  templateUrl: './configuracion-motivos-de-desbloqueos.component.html',
  styleUrls: ['./configuracion-motivos-de-desbloqueos.component.css']

})
export class ConfiguracionMotivosDeDesbloqueosComponent implements OnInit {

  public DAT_TITULOS: any = moduloGaritas.titulos.configuracionMotivosDeDesbloqueos;
  public DAT_BTNS: any = moduloGaritas.button.buttonsNombre;
  public DAT_BTNCSS: any = moduloGaritas.button.buttonsCss;
  public DAT_AG_GRID: any = moduloGaritas.agGrid;
  public DAT_MSG: any = moduloGaritas.mensajes;

  public gridApi: any;
  public gridColumnApi: any;
  public frameworkComponents: any;
  public columnDefs: any[] = [];
  public rowData: any[] = [];
  public garitaSelect: IGaritaResponse[] = [];
  public basculaSelect: IMantBascula[] = [];

  public isCreate: boolean = false;
  public tituloModal: string = '';
  public loading: boolean = false;
  public showUsers: boolean = false;

  public agregarForm = new FormGroup({
    id: new FormControl(null),
    descripcion: new FormControl(null, [Validators.required, Validators.maxLength(50)]),
    estado: new FormControl(null, [Validators.required]),

    compra: new FormControl(true),
    venta: new FormControl(false),
    traslado: new FormControl(false),
    informativo: new FormControl(false),
    maquila: new FormControl(false),

    difCalidad: new FormControl(false),
    difPesos: new FormControl(false),
    anulacion: new FormControl(false),

    //SOLO MOTIVOS DE PLANIFICACION
    enPlanificacion: new FormControl(false),
  });

  tipoOrdenSeleccionado = false;
  activoParaSeleccionado = false;
  public cmbUsuarios: IUsuarioAll[] = [];
  private subscription = new Subscription();

  constructor(
    private _util: UtilsService,
    private usuarioBasculaGaritaS: UsuarioBasculaGaritaService,
    private basculaService: MantenimientoBasculaService,
    private garitasService: MantenimientoGaritasService,
    private usuariosService: UsuariosService,
    private ConfiguracionMotivosDeDesbloqueosService: ConfiguracionMotivosDeDesbloqueosService
  ) {
  }

  onChangeTipoOrden() {
    console.log("compra", this.agregarForm.get("compra").value)
    if (
      this.agregarForm.get("compra").value == true ||
      this.agregarForm.get("venta").value == true ||
      this.agregarForm.get("traslado").value == true ||
      this.agregarForm.get("informativo").value == true ||
      this.agregarForm.get("maquila").value == true
    ) {
      this.tipoOrdenSeleccionado = true;
    } else {
      this.tipoOrdenSeleccionado = false;
    }
  }

  onChangeActivoPara() {
    if (
      this.agregarForm.get("difCalidad").value == true ||
      this.agregarForm.get("difPesos").value == true ||
      this.agregarForm.get("anulacion").value == true
    ) {
      this.activoParaSeleccionado = true;
    } else {
      this.activoParaSeleccionado = false;
    }
  }

 /* onChangeAplicaPara() {
    if (
      this.agregarForm.get("difCalidad").value == true ||
      this.agregarForm.get("difPesos").value == true ||
      this.agregarForm.get("anulacion").value == true
    ) {
      this.activoParaSeleccionado = true;
    } else {
      this.activoParaSeleccionado = false;
    }
  }*/

  ngOnInit() {
    this.girdComponent();
    this.obtenerTodo();

    // this.agregarForm.get('dif_calidad').setValue('false');
    // this.agregarForm.get('dif_pesos').setValue('false');
    // this.agregarForm.get('anulacion').setValue('false');
  }

  girdComponent() {
    this.frameworkComponents = { buttonRenderer: LfsaBotonEditarGridComponent, };

    this.columnDefs = [
      {
        headerName: '', cellRenderer: 'buttonRenderer', width: 80,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info,
        },
      },
      { headerName: 'Motivo Id', field: 'id', sortable: true, filter: true, width: 100 },
      { headerName: 'Descripción', field: 'description', sortable: true, filter: true },
      { headerName: 'Status', field: 'estado', sortable: true, filter: true, width: 100 },
      { headerName: 'Aplica a:', field: 'tipoOrd', sortable: true, filter: true },
      { headerName: 'Planificacion/Balanza:', field: 'enPlanificacion', sortable: true, filter: true,
        valueGetter: function(params){return (params.data.enPlanificacion === true) ? 'Planificaciones' : 'Balanza'; }
      }
    ];
  }

  obtenerTodo() {
    this.loading = true;
    this.subscription.add(
      this.ConfiguracionMotivosDeDesbloqueosService.obtener().subscribe(
        (resp) => {
          this.rowData = resp;
          this.loading = false;
        },
        (error) => {
          this.rowData = [];
          this.loading = false;
        }
      )
    );
  }

  guardarCrearNueva() {
    this.loading = true;
    if (this.agregarForm.invalid) return;
    let data = this.agregarForm.getRawValue();

    data.difCalidad = (data.difCalidad) ? "true" : "false";
    data.difPesos = (data.difPesos) ? "true" : "false";
    data.anulacion = (data.anulacion) ? "true" : "false";

    // envia "Compra|Venta"
    // recibe ["Compra", "Venta"]

    data.tipoOrd = "";

    if (data.compra)
      data.tipoOrd = data.tipoOrd + "Compra|";
    if (data.venta)
      data.tipoOrd = data.tipoOrd + "Venta|";
    if (data.traslado)
      data.tipoOrd = data.tipoOrd + "Traslado|";
    if (data.informativo)
      data.tipoOrd = data.tipoOrd + "Informativo|";
    if (data.maquila)
      data.tipoOrd = data.tipoOrd + "Maquila|";

    data.tipoOrd = (data.tipoOrd).slice(0, -1);

    let formData = Object.assign(
      {
        "descripcion": data.descripcion,
        "estado": parseInt(data.estado),
        "tipoOrd": data.tipoOrd,
        "difCalidad": data.difCalidad,
        "difPesos": data.difPesos,
        "anulacion": data.anulacion,
        "enPlanificacion" : data.enPlanificacion
      },
    );

    console.log("formData", formData)
    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.procesar,
        text: `Usuario: ${data.idusuario} ${data.bascula ? `- Báscula: ${data.bascula}` : ``} ${data.garita ? `- Garita: ${data.garita}` : ``}`,
        action: this.DAT_BTNS.nuevo,
        funcion: this.ConfiguracionMotivosDeDesbloqueosService.crear(formData),
      })
      .then(() => {
        this.obtenerTodo();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  guardarEditar() {
    this.loading = true;
    if (this.agregarForm.invalid) return;
    let data = this.agregarForm.getRawValue();

    data.difCalidad = (data.difCalidad) ? "true" : "false";
    data.difPesos = (data.difPesos) ? "true" : "false";
    data.anulacion = (data.anulacion) ? "true" : "false";

    // envia "Compra|Venta"
    // recibe ["Compra", "Venta"]

    data.tipoOrd = "";

    if (data.compra)
      data.tipoOrd = data.tipoOrd + "Compra|";
    if (data.venta)
      data.tipoOrd = data.tipoOrd + "Venta|";
    if (data.traslado)
      data.tipoOrd = data.tipoOrd + "Traslado|";
    if (data.informativo)
      data.tipoOrd = data.tipoOrd + "Informativo|";
    if (data.maquila)
      data.tipoOrd = data.tipoOrd + "Maquila|";

    data.tipoOrd = (data.tipoOrd).slice(0, -1);

    let formData = Object.assign(
      {
        "id": data.id,
        "descripcion": data.descripcion,
        "estado": parseInt(data.estado),
        "tipoOrd": data.tipoOrd,
        "difCalidad": data.difCalidad,
        "difPesos": data.difPesos,
        "anulacion": data.anulacion,
        "enPlanificacion" : data.enPlanificacion
      },
    );

    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.actualizar,
        text: "`Actualiza motivo : ${data.id} - ${data.descripcion} `",
        action: this.DAT_BTNS.editar,
        funcion: this.ConfiguracionMotivosDeDesbloqueosService.editar(formData),
      })
      .then(() => {
        this.obtenerTodo();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  eliminar({rowData}) {
    this.loading = true;
    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        text: `Usuario: ${rowData.idusuario} ${rowData.bascula ? `- Báscula: ${rowData.bascula}` : ``} ${rowData.garita ? `- Garita: ${rowData.garita}` : ``}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this.ConfiguracionMotivosDeDesbloqueosService.eliminar(rowData.id),
      })
      .then((res: any) => {
        this.obtenerTodo();
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
      });
  }

  nuevo() {
    this.isCreate = true;
    this.tituloModal = this.DAT_TITULOS.tituloAgregar;
    this.agregarForm.reset();
    this.agregarForm.get('id').disable({onlySelf: true});
    this.openModal();
  }

  editar({rowData}) {
    console.log("rowData", rowData)

    this.isCreate = false;
    this.tituloModal = this.DAT_TITULOS.tituloActualizar;
    this.agregarForm.reset();
    this.agregarForm.patchValue(rowData);
    this.agregarForm.get('id').disable({onlySelf: true});
    this.agregarForm.get('estado').setValue(rowData.estado == "INACTIVO" ? 1 : 0);
    this.agregarForm.get('descripcion').setValue(rowData.description);

    let tipoOrd = rowData.tipoOrd.toString();

    if (tipoOrd.indexOf("Venta") >= 0) this.agregarForm.get('venta').setValue(true);
    if (tipoOrd.indexOf("Compra") >= 0) this.agregarForm.get('compra').setValue(true);
    if (tipoOrd.indexOf("Maquila") >= 0) this.agregarForm.get('maquila').setValue(true);
    if (tipoOrd.indexOf("Traslado") >= 0) this.agregarForm.get('traslado').setValue(true);
    if (tipoOrd.indexOf("Informativo") >= 0) this.agregarForm.get('informativo').setValue(true);

    console.log("rowData.difPesos", rowData.difPesos)
    console.log("rowData.difPesos == true ?", (rowData.difPesos == "true") ? true : false)
    if (rowData.difPesos == "true") this.agregarForm.get('difPesos').setValue(true);
    else this.agregarForm.get('difPesos').setValue(false);
    if (rowData.anulacion == "true") this.agregarForm.get('anulacion').setValue(true);
    else this.agregarForm.get('anulacion').setValue(false);
    if (rowData.difCalidad == "true") this.agregarForm.get('difCalidad').setValue(true);
    else this.agregarForm.get('difCalidad').setValue(false);

    this.openModal();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    if (this.isCreate) this.guardarCrearNueva();
    if (!this.isCreate) this.guardarEditar();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
